"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var lodash_1 = require("lodash");
var item_loading_1 = tslib_1.__importDefault(require("../slider/item-loading/item-loading"));
var get_thumbnail_min_width_attribute_1 = tslib_1.__importDefault(require("../slider/get-thumbnail-min-width-attribute"));
var thumbnail_scss_1 = tslib_1.__importDefault(require("./thumbnail.scss"));
var compiled_1 = require("../../../icons/compiled");
var picture_1 = require("../../../common/components/picture");
var THUMBNAIL_RATIO = 9 / 16;
var Thumbnail = /** @class */ (function (_super) {
    tslib_1.__extends(Thumbnail, _super);
    function Thumbnail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stopPropagation = function (event) {
            event.stopPropagation();
        };
        return _this;
    }
    Thumbnail.prototype.getCoverStyle = function () {
        return tslib_1.__assign(tslib_1.__assign({}, this.getSize()), { backgroundImage: "url(".concat(this.props.backgroundUrl, ")") });
    };
    Thumbnail.prototype.getSize = function () {
        var width = this.props.width;
        if (width) {
            var height = width * THUMBNAIL_RATIO;
            return { width: width, height: height };
        }
        return {};
    };
    Thumbnail.prototype.getMinWidthAttributte = function () {
        var width = this.props.width;
        if (width) {
            return {
                'data-thumbnail-min-width': (0, get_thumbnail_min_width_attribute_1.default)(width),
            };
        }
        return {};
    };
    Thumbnail.prototype.renderLiveLabel = function () {
        var _a;
        var _b = this.props, width = _b.width, showLiveLabel = _b.showLiveLabel, liveLabel = _b.liveLabel, isRTL = _b.isRTL;
        if (!showLiveLabel) {
            return null;
        }
        var liveLabelStyles = (0, classnames_1.default)(thumbnail_scss_1.default['live-label'], (_a = {},
            _a[thumbnail_scss_1.default.rtl] = isRTL,
            _a[thumbnail_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { className: liveLabelStyles }, react_1.default.cloneElement(liveLabel, { thumbnailWidth: width })));
    };
    Thumbnail.prototype.renderButtons = function () {
        var _a;
        var _b = this.props, buttons = _b.buttons, isRTL = _b.isRTL;
        if (!buttons) {
            return null;
        }
        var buttonsStyles = (0, classnames_1.default)(thumbnail_scss_1.default.buttons, (_a = {},
            _a[thumbnail_scss_1.default.rtl] = isRTL,
            _a[thumbnail_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { onClick: this.stopPropagation, className: buttonsStyles }, buttons));
    };
    Thumbnail.prototype.getCoverClassName = function () {
        var _a;
        var _b = this.props, showLiveLabel = _b.showLiveLabel, showButtonsOnHover = _b.showButtonsOnHover, isRTL = _b.isRTL;
        return (0, classnames_1.default)(thumbnail_scss_1.default.thumbnail, (_a = {},
            _a[thumbnail_scss_1.default['show-live-label']] = showLiveLabel,
            _a[thumbnail_scss_1.default['buttons-on-hover']] = showButtonsOnHover,
            _a[thumbnail_scss_1.default.rtl] = isRTL,
            _a[thumbnail_scss_1.default.ltr] = !isRTL,
            _a));
    };
    Thumbnail.prototype.renderContent = function () {
        var _a;
        var _b = this.props, content = _b.content, isRTL = _b.isRTL;
        if (!content) {
            return null;
        }
        var contentStyle = (0, classnames_1.default)(thumbnail_scss_1.default.content, (_a = {},
            _a[thumbnail_scss_1.default.rtl] = isRTL,
            _a[thumbnail_scss_1.default.ltr] = !isRTL,
            _a));
        return react_1.default.createElement("div", { className: contentStyle }, content);
    };
    Thumbnail.prototype.renderDuration = function () {
        var _a;
        var _b = this.props, duration = _b.duration, isRTL = _b.isRTL;
        if (!duration) {
            return null;
        }
        var durationStyles = (0, classnames_1.default)(thumbnail_scss_1.default.duration, (_a = {},
            _a[thumbnail_scss_1.default.rtl] = isRTL,
            _a[thumbnail_scss_1.default.ltr] = !isRTL,
            _a));
        return react_1.default.createElement("div", { className: durationStyles }, duration);
    };
    Thumbnail.prototype.render = function () {
        var _a, _b, _c, _d;
        var _e = this.props, width = _e.width, onClick = _e.onClick, overlayClassName = _e.overlayClassName, isFocusable = _e.isFocusable, isLoading = _e.isLoading, ariaLabel = _e.ariaLabel, dataHook = _e.dataHook, isRTL = _e.isRTL, isPaid = _e.isPaid, useResponsiveThumbnail = _e.useResponsiveThumbnail, backgroundSrc = _e.backgroundSrc, breakpoints = _e.breakpoints, videoTitle = _e.videoTitle;
        var containerStyle = (0, classnames_1.default)(thumbnail_scss_1.default.container, (_a = {},
            _a[thumbnail_scss_1.default.loading] = isLoading,
            _a[thumbnail_scss_1.default.rtl] = isRTL,
            _a[thumbnail_scss_1.default.ltr] = !isRTL,
            _a[thumbnail_scss_1.default.stretch] = Boolean(breakpoints),
            _a));
        var wrapperStyle = (0, classnames_1.default)(thumbnail_scss_1.default.wrapper, (_b = {},
            _b[thumbnail_scss_1.default.rtl] = isRTL,
            _b[thumbnail_scss_1.default.ltr] = !isRTL,
            _b));
        var loaderStyle = (0, classnames_1.default)(thumbnail_scss_1.default.loader, (_c = {},
            _c[thumbnail_scss_1.default.rtl] = isRTL,
            _c[thumbnail_scss_1.default.ltr] = !isRTL,
            _c));
        var overlayStyle = (0, classnames_1.default)(thumbnail_scss_1.default.overlay, overlayClassName, (_d = {},
            _d[thumbnail_scss_1.default.rtl] = isRTL,
            _d[thumbnail_scss_1.default.ltr] = !isRTL,
            _d[thumbnail_scss_1.default.absolute] = useResponsiveThumbnail,
            _d));
        var overlay = (react_1.default.createElement("div", { className: overlayStyle },
            this.renderLiveLabel(),
            this.renderButtons(),
            this.renderDuration(),
            isPaid && react_1.default.createElement(compiled_1.DollarIcon, { className: thumbnail_scss_1.default.paidIcon })));
        var pictureWidth = width || 320;
        var pictureBreakpoints = breakpoints || [
            {
                min: 0,
                width: pictureWidth,
                height: (pictureWidth / 16) * 9,
            },
        ];
        return (react_1.default.createElement("div", tslib_1.__assign({}, this.getMinWidthAttributte(), { style: { width: width }, className: containerStyle, onClick: onClick, "data-hook": dataHook, "aria-hidden": !isFocusable }),
            react_1.default.createElement("div", { className: wrapperStyle, tabIndex: isFocusable ? 0 : -1, "aria-label": ariaLabel },
                isLoading ? (react_1.default.createElement("div", { className: loaderStyle, style: this.getSize() },
                    react_1.default.createElement(item_loading_1.default, { active: isLoading }))) : (react_1.default.createElement("div", { className: this.getCoverClassName(), "data-hook": "thumbnail-cover", style: useResponsiveThumbnail ? {} : this.getCoverStyle() }, useResponsiveThumbnail ? (react_1.default.createElement(picture_1.Picture, { alt: videoTitle, src: backgroundSrc, breakpoints: pictureBreakpoints }, overlay)) : (overlay))),
                this.renderContent())));
    };
    Thumbnail.displayName = 'Thumbnail';
    Thumbnail.defaultProps = {
        onClick: lodash_1.noop,
        dataHook: 'video-list-thumb-wrapper',
    };
    return Thumbnail;
}(react_1.default.Component));
exports.default = Thumbnail;
//# sourceMappingURL=thumbnail.js.map